import React, { useEffect } from 'react'

import {
    modal as modalStyle,
    show as showStyle,
    content as contentStyle
} from "./Modal.module.css"

export default function Modal({id, handleClose, show, children }) {

    // add/remove click event handler to the document
    useEffect(() => {
        const clickHandlerForModal = ({ target }) => {
            const container = document.getElementById(id)

            if(container.contains(target) || target.getAttribute("id") === `${id}_btn`){
                // do nothing if we click inside search window or on a button that opens modal window
                return
            }
           
            handleClose()
        }

        document.addEventListener("click", clickHandlerForModal)

        // these functions clean up the event listeners
        return () => document.removeEventListener("click", clickHandlerForModal)
    })      

    return(       
        <div className={show ? `${modalStyle} ${showStyle}` : modalStyle} >
            <div id={id} className={contentStyle}>
                {children}
                {/* <button onClick={handleClose}>close</button> */}
            </div>
        </div>
    )
}